'use client';

import { ArrowDownThinIcon, SportsColoredIcon, SportsIcon } from '@repo/icons';
import { SideMenuItem } from '@repo/ui/side-menu-item';
import { cn } from '@repo/utils/cn';
import { useTranslations } from 'next-intl';
import { memo } from 'react';
import { renderIcon } from '@/components/layout/sidebar-left/render-icon';
import SportCategories from '@/components/layout/sidebar-left/sports/sport-categories';
import { useTenant } from '@/providers/TenantProvider';

type SportsProps = {
  sidebarOpen: boolean;
  onClick: () => void;
  isActive: boolean;
};

const Sports = ({ sidebarOpen, onClick, isActive }: SportsProps) => {
  const t = useTranslations('sidebar-left');

  const { tenantMachineName } = useTenant();

  return (
    <div className="w-full">
      <SideMenuItem
        text={sidebarOpen && t('sports')}
        isActive={isActive}
        Icon={renderIcon(SportsIcon, SportsColoredIcon, tenantMachineName)}
        onClick={onClick}
        className={cn(isActive && 'rounded-b-none')}
        optionalLastElement={
          sidebarOpen && (
            <ArrowDownThinIcon className={cn('transition-transform duration-300', isActive && 'rotate-180')} />
          )
        }
        tooltipText={t('sports')}
        showTooltip={!sidebarOpen}
      />
      <div className={cn('grid transition-all duration-300', isActive ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]')}>
        <div className="overflow-hidden rounded-sm">
          <SportCategories sidebarOpen={sidebarOpen} />
        </div>
      </div>
    </div>
  );
};

export default memo(Sports, (prevProps, nextProps) => {
  return prevProps.sidebarOpen === nextProps.sidebarOpen && prevProps.isActive === nextProps.isActive;
});
